import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { ReversionRemisionService } from './reversion-remision.service';

/**
 * Módulo mínimo (sólo depende de Prisma) para que tanto `NotaRemisionModule`
 * como `MiddlewareSifenModule` puedan revertir una remisión sin crear un ciclo
 * de dependencias entre ellos.
 */
@Module({
  imports: [PrismaModule],
  providers: [ReversionRemisionService],
  exports: [ReversionRemisionService],
})
export class ReversionRemisionModule {}
